import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  appointmentSettings,
  getAppointments,
} from "../../../api/appointments";

export const fetchAppointments = createAsyncThunk(
  "/appointments",
  async (payload) => {
    const res = await getAppointments(payload);
    return res;
  }
);
export const fetchAppointmentsSetting = createAsyncThunk(
  `/appointment/service`,
  async () => {
    const res = await appointmentSettings();
    return res;
  }
);
const appointmentsSettingSlice = createSlice({
  name: "appointment",
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppointmentsSetting.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAppointmentsSetting.fulfilled, (state, action) => {
        state.value = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchAppointmentsSetting.rejected, (state) => {
        state.error = true;
      });
  },
});
const appointmentsSlice = createSlice({
  name: "appointment",
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppointments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAppointments.fulfilled, (state, action) => {
        state.value = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchAppointments.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
      });
  },
});

export { appointmentsSlice, appointmentsSettingSlice };
